import type { ICouponRepository, IGetCouponUseCase } from '../../../domain/entry.js';

type Execute = ReturnType<IGetCouponUseCase['execute']>;
type GetSnapshotReturn = ReturnType<Execute[0]>;
type GetSubscribeReturn = ReturnType<Execute[1]>;

/**
 * Use case for getting an active coupon by its identifiers, couponId and couponIndex.
 *
 * @param couponRepository Coupon repository dependency
 * @returns Use case executor for retrieving a coupon
 */
export function getCouponUseCase(couponRepository: ICouponRepository): IGetCouponUseCase {
  return {
    execute: ({ couponId, couponIndex }): Execute => {
      return [
        (): GetSnapshotReturn => couponRepository.getCouponModel({ couponId, couponIndex }),
        (subscribeFn): GetSubscribeReturn => couponRepository.subscribeCoupon({ couponId, couponIndex }, subscribeFn),
      ] as const;
    },
  };
}
